import {Columns} from '@shared/interfaces/table/column-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * UnitType Partial Translation Cell
 * Translates unitType enums into relevant translations
 */
export const unitTypePartial: Columns<any> = {
  title: 'table.unittype.title',
  key: 'unitType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'kwh': 'enum.meteringpoint.unittype.kwh',
    'kva': 'enum.meteringpoint.unittype.kva',
    'kvarh': 'enum.meteringpoint.unittype.kvarh',
    'kvar': 'enum.meteringpoint.unittype.kvar',
    'wh': 'enum.meteringpoint.unittype.wh',
    'varh': 'enum.meteringpoint.unittype.varh',
    'var': 'enum.meteringpoint.unittype.var',
    'notspecified': 'enum.meteringpoint.unittype.notspecified',
  }
}
